import React from "react";

const images = "/Banner/background-count-number.png"; // Background image path

const ScrollableCards = () => {
  const cards = [
    { Number: "100+", Title: "Trainers" },
    { Number: "50+", Title: "Courses" },
    { Number: "150+", Title: "Members" },
    { Number: "10+", Title: "Countries" },
  ];

  return (
    <section className="relative w-full ">
      {/* Background Image */}
      <img src={images} alt="megascale" className="w-full h-full object-cover" />

      {/* Overlay for Readability */}
      <div className="absolute inset-0 flex items-center justify-center text-center p-4">
        <div className="grid grid-cols-4  gap-6 w-full ">
          {cards.map((card, index) => (
            <div key={index} className="p-6 px-1 text-white space-y-2">
              <h2 className="text-3xl md:text-4xl font-bold drop-shadow-lg">{card.Number}</h2>
              <p className="text-lg md:text-2xl font-semibold drop-shadow-lg">{card.Title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ScrollableCards;
